<div class=" mt-4">
  <section class="my-4">
    <div class="scrollmenu">
      <a [routerLink]="['/PayOut/AccountBalance']">Account Balance</a>
      <a [routerLink]="['/PayOut/ManagePayOutContact']">PayOut Contact</a>
      <a routerLinkActive="active" class="active menu" [routerLink]="['/PayOut/BeneficiaryList']">PayOut Beneficiary</a>

      <!-- <a [routerLink]="['/PayOut/PayoutLedgers']">PayOut Ledger</a> -->
      <a [routerLink]="['/PayOut/PayOutTransactions']">PayOut Transaction</a>
      <a [routerLink]="['/PayOut/PayOutBatches']">PayOut settlement</a>
      <!-- <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a> -->
      <a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a>
      <!-- <a  [routerLink]="['/PayOut/PayoutPostback']">PayOut PostBack Url</a> -->
      <!-- <a [routerLink]="['/PayOut/PayoutReports']">Reports</a>
      <a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a>-->
    </div>
  </section>
  <section>
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
          <div class="dropdown d-inline">
            <button class="dash-btns btn mr-3" type="button" data-bs-toggle="dropdown">Download &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a  id="btnExportBatch" (click)="readAndExportToExcelData()">Excel</a></li>
            </ul>
          </div>
          <!-- <a class="box-button" type="button" id="filtering" (click)="filters()" tooltip="Filter"
                    aria-describedby="tooltip-9">  <img src="assets/img/filter-icon.png" alt="" style="width: 20px; height: 20px;"></a>
                  -->
          <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"> <i class="fa fa-filter" aria-hidden="true"></i> Filter</button>
        </div>
      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please click
          onFilter</small>
      </div>
    </div>

    <div class="row  my-4" *ngIf="filtering">
      <div class="col-md-12">
        <div class="card-1 p-4">
          <h4 class="font-26 gary-t">Filter Your Result</h4>
          <p>Please Fill the details to filter your result</p>
          <div class="col-md-12">
            <!-- filtering starts -->
            <form>
              <div class="row m-0">
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel"> Date</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="Range" id="daterange" placeholder="Select date" [formControl]="daterange"
                      (ngModelChange)="checkRangeType()" required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">


                  <div class="form-group">
                    <label class="customlabel"> From Date</label>
                    <input type="date" class="formcontrol-user1 form-control" placeholder="From Date" id="fromdate"
                      [formControl]="fromdate"  (change)="checkDateRange()">
                  </div>

                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                  <div class="form-group">
                    <label class="customlabel"> To Date</label>
                    <input type="date" class="formcontrol-user1 form-control" placeholder="To Date" id="todate"
                      [formControl]="todate"  (change)="checkDateRange()">
                  </div>
                  <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To
                    Date</span>
                </div>


                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel"> PayOut Beneficiary KeyId</label>
                    <input type="text" class="formcontrol-user1 form-control" placeholder="PayOut Beneficiary KeyId"
                      id="PayOutBeneficiaryKeyId" [formControl]="PayOutBeneficiaryKeyId">
                  </div>
                </div>

                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel"> PayOut Customer KeyId</label>
                    <input type="text" class="formcontrol-user1 form-control" placeholder="PayOut Customer KeyId"
                      id="PayOutCustomerKeyId" [formControl]="PayOutCustomerKeyId">
                  </div>
                </div>


                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel"> Account No</label>
                    <input type="text" class="formcontrol-user1 form-control" placeholder="Account No" id="AccountNo" (keypress)="numberOnly($event)"
                      [formControl]="AccountNo">
                  </div>
                </div>
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel"> Bank Name</label>
                    <input type="text" class="formcontrol-user1 form-control" placeholder="Bank Name" id="BankName"
                      [formControl]="BankName">
                  </div>
                </div>
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel"> Beneficiary Name</label>
                    <input type="text" class="formcontrol-user1 form-control" placeholder="Beneficiary Name" id="BeneficiaryName"
                      [formControl]="BeneficiaryName">
                  </div>
                </div>
              </div>
            </form>
            <!-- filtering ends -->
          </div>
          <div class="col-md-12 text-right">
            <div style="display: inline-block;  margin-right:5px;" class="text-right mt-3" *ngIf="!isCustomDateSelected">
              <button class="btn dash-btns" type="button" id="filtering" (click)="selectedaterange()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>

            <div style="display: inline-block;  margin-right:5px;" class="text-right mt-3" *ngIf="isCustomDateSelected">
              <button class="btn dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive"
                (click)="search()" matTooltip="New Sale Transaction"> Search</button>
            </div>
            <div style="display: inline-block;  margin-right:5px;" class="text-right">

              <button type="reset" class="dash-btns" (click)="resetForm()"

                matTooltip="New Sale Transaction">Reset</button>

            </div>
            <!-- <a href="" style="color: #d40055;">Clear</a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="row">
          <ngx-datatable-column name="Action">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewBeneficiaries',{Id: row.Id}]" data-toggle="tooltip"
                data-placement="top" title="View">
                <img src="./assets/ViewDetails.svg">
              </a>
              <a class="edit btn btn-demo" (click)="viewbeneficiarydetails(row.MerchantKeyId,row.PayoutCustomerkeyId)" data-bs-toggle="modal" data-bs-target="#myModal2" data-bs-placement="top" title="Basic View">
                <em class="fa-1x mr-2 fas fa-eye"></em>
              </a>
              <a class=" edit pl-1 d-inline" *ngIf="row.Status==1 && editbenificiary"
                [routerLink]="['/PayOut/AddBeneficiaries',{EditId:row.Id}] " data-toggle="tooltip" data-placement="top"
                title="Edit"> <em class="fas fa-edit mr-2"></em>
              </a>
              <a class="edit pl-1 d-inline" [routerLink]="['/PayOut/DeleteBeneficiarie',{Id: row.Id}]"
                data-toggle="tooltip" data-placement="top" title="Delete" *ngIf="deletebenificiary">
                <em class="far fa-trash-alt" ></em>
              </a>
            </ng-template>
          </ngx-datatable-column>

          <!-- <ngx-datatable-column name="Status">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="status-warning-btn " *ngIf="row.Status==1">
                Pending
              </span>
              <span class="status-approved-btn" *ngIf="row.Status==2">
             Approved
              </span>

            </ng-template>
          </ngx-datatable-column> -->
          <ngx-datatable-column name="Status check" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span *ngIf="row.Status==1 && verifystatus">
                <span class="status-warning-btn" (click)="verificationbenficiarie(row.PayOutBeneficiaryKeyId)">Verify
                  beneficiary</span>
              </span>
              <span *ngIf="row.Status==2">
                <span class="status-approved-btn">Verified</span>
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="PayoutCustomerkeyId" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayoutCustomerkeyId}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="PayOutBeneficiaryKeyId">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayOutBeneficiaryKeyId}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="AccountNumber">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.AccountNumber}}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Beneficiary Name">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.BeneficiaryName}}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="BankName">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.BankName}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="BranchName">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.BranchName}}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="UpdatedDatetime">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.UpdatedDatetime | date:'d/M/yy, h:mm a' }}</div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </section>
</div>


<div class="modal right fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h4 class="modal-title" id="myModalLabel2">View Beneficiary Details</h4>
      </div>

      <div class="modal-body">
        <div class="row mt-3 mb-3">
          <div class="col-md-12">
            <div class="row  my-3">
                <div class="col-md-6">
                    <label>PayOut BeneficiaryKeyId</label>
                </div>
                <div class="col-md-6">
                    <div class="view-text">{{rowdata.PayOutBeneficiaryKeyId}}</div>


                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label> Payout CustomerkeyId
                    </label>
                </div>
                <div class="col-md-6">
                    <div class="view-text"> {{rowdata.PayoutCustomerkeyId}}</div>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>Beneficiary Name</label> </div>

                <div class="col-md-6 view-text "> {{rowdata.BeneficiaryName}}
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>Bank CodeType</label> </div>

                <div class="col-md-6 view-text  ">{{rowdata.BankCodeType}} </div>
            </div>

            <div class="row my-3">
                <div class="col-md-6">
                    <label>Bank Name </label>
                </div>
                <div class="col-md-6 view-text ">{{rowdata.BankName}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Branch Name </label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.BranchName}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Address </label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.Address}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>City</label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.City}}
                </div>
            </div>



            <div class="row my-3">

                <div class="col-md-6">
                    <label>State</label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.State}}</div>
            </div>

            <div class="row my-3">
                <div class="col-md-6">
                    <label>ZipCode </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.ZipCode}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>BankCode/IFSC Code </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.BankCode}}</div>
            </div>






        </div>
        <div class="col-md-12">
            <div class="row my-3">

                <div class="col-md-6">
                    <label>AccountNumber </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.AccountNumber}}</div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label>Bank AccountType</label>
                </div>

                <div class="col-md-6 view-text robot">{{rowdata.BankAccountType}} </div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label>Bank Country </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.BankCountry}} </div>

            </div>

            <div class="row my-3">

                <div class="col-md-6">
                    <label>Verification Status </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.VerificationStatus}}</div>

            </div>

            <div class="row my-3">

              <div class="col-md-6">
                  <label>Verification Response </label>
              </div>

              <div class="col-md-6 view-text">{{rowdata.VerificationResponse}}</div>

          </div>
          <div class="row my-3">

            <div class="col-md-6">
                <label>UpiVpa </label>
            </div>

            <div class="col-md-6 view-text">{{rowdata.UpiVpa}}</div>

        </div>
        <div class="row my-3">

          <div class="col-md-6">
              <label>Prefer PayOut Account </label>
          </div>

          <div class="col-md-6 view-text">{{rowdata.PreferPayOutAccount}}</div>

      </div>
      <div class="row my-3">

        <div class="col-md-6">
            <label>Updated Datetime </label>
        </div>

        <div class="col-md-6 view-text">{{rowdata.UpdatedDatetime | date:'d/M/yy,
          h:mm a'}}</div>

    </div>










        </div>
        </div>
      </div>

    </div><!-- modal-content -->
  </div><!-- modal-dialog -->
</div><!-- modal -->
